const OrderConfirmationEmailService = function (restangular) {
    this._api = restangular.one('Checkout');
};

OrderConfirmationEmailService.prototype.sendOrderConfirmationEmail = function (orderId, toAddress) {
    return this._api.post('ConfirmOrderEmail', { OrderId: orderId, ToAddress: toAddress });
};

module.exports = OrderConfirmationEmailService;



// WEBPACK FOOTER //
// ./src/order/confirmation/order-confirmation-export-email.service.js